import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { keyBy } from "lodash";
import classNames from "classnames";
import { useLocation } from 'react-router-dom';
import { useGetState, useAsyncEffect } from "ahooks";

import { download, unpackZip, blobToBase64 } from "@/utils/file.js";
import DB from "@/utils/db.js";

import styles from "./SkinStatusItem.less";
import CheckState from "./CheckState";


SkinStatusItem.displayName = "SkinStatusItem";

SkinStatusItem.propTypes = {
  data: PropTypes.object,
};

function SkinStatusItem(props) {
  const {
    data: { images, instances, icon, zips, three_dimensional },
  } = props;

  const location = useLocation();
  const { search } = location;

  const [DBInstance, setDBInstance, getDBInstance] = useGetState();

  const [featureImageMap, setFeatureImageMap] = useState({});

  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    if (search) {
      setDBInstance(new DB({ storeName: search.substring(1) }));
    }
  }, [search]);

  const getDBKey = (info) => {
    return info?.filename?.split("/").pop();
  };

  const preload = useCallback(async () => {
    const info = await download({
      url: zips?.thumb?.url,
      flag: zips?.thumb?.url,
      onProgress: ({ loaded, total }) => {
        setProgressValue(Math.floor((loaded / total) * 100));
      },
    });
    if (info.status) {
      const unpackInfo = await unpackZip({ zipBlob: info.blob });
      await Promise.all(
        unpackInfo.map(async (item) => {
          const [key, blob] = Object.entries(item)?.[0];
          if (!blob) return;
          const base64Info = await blobToBase64(blob);
          if (base64Info.status) {
            return await DBInstance.addItem(key, base64Info.texture);
          }
        })
      );
    }
  }, [DBInstance]);

  const getThumbList = async () => {
    const mappingMap = keyBy(three_dimensional.mappings, 'flag');
    const fileNameList = (instances || []).map(instance => {
      return (instance?.features || []).map(feature => {
        const mapping = feature.mappings.find((item) => item.flag !== 'rgb_cool') || feature.mappings[0];
        return { id: feature.id, filename: mappingMap[mapping.flag].thumb_filename.split('/').pop() }
      })
    }).flat(Infinity)

    const textureList = await Promise.all(fileNameList.map(async (item) => {
      const blob = await DBInstance.getItem(item.filename);
      return { id: item.id, url: blob }
    }))
    setFeatureImageMap(keyBy(textureList, 'id'));
  }
  useAsyncEffect(async () => {
    if (DBInstance) {
      const key = getDBKey(images[0]);
      // setLoading(true);
      const hasPreload = await DBInstance.hasKey(key);
      console.log('hasPreload: ', hasPreload);
      if (!hasPreload) {
        await preload();
      }
      setProgressValue(100);
      getThumbList();
      // setLoading(false);

    }
  }, [DBInstance]);

  return (
    <div className={styles.skinStatusItemWrap}>
      {instances?.map((instance, index) => {
        return (
          <div id={instance.name} key={instance.id} className={classNames(styles.instanceItem, {
            [styles.lastInstanceItem]: index === instances?.length - 1,
          })}>
            {instance?.features?.map((item) => {
              return (
                <div key={item.id} className={styles.skinStatusItemContent}>
                  <CheckState
                    progressValue={progressValue}
                    featureImage={featureImageMap[item.id]?.url}
                    featureItem={{ ...item, instanceName: instance.name, instanceDegree: instance.degree, instanceLevel: instance.level }}
                    featureList={instance?.features}
                    images={images}
                    flag={images[0]?.flag}
                    downloadUrl={zips?.thumb?.url}
                  />
                </div>
              );
            })}
          </div>
        )
      })
      }
    </div>
  );
}
export default SkinStatusItem;
